/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_copyArray.js
// module id = ./node_modules/lodash/_copyArray.js
// module chunks = 2345137460201621000